<script lang="ts">
import { defineComponent, h, computed, Slots, PropType } from 'vue'
import { Sizes } from '@/types/sizes'
export default defineComponent({
  props: {
    level: { type: [String, Number], default: 2 },
    size: { type: String as PropType<Sizes>, default: Sizes.Medium },
  },
  setup(props: { level: string | number; size: Sizes }, { slots }: { slots: Slots }) {
    const headlineLevel = computed((): string => {
      return `h${props.level}`
    })
    const sizes = computed((): string => {
      if (props.size === Sizes.XLarge) return `font-semibold text-2xl-mobile md:text-2xl`
      if (props.size === Sizes.Large) return `font-semibold text-xl-mobile md:text-xl`
      if (props.size === Sizes.Medium) return `font-semibold text-lg`
      if (props.size === Sizes.Small) return `font-semibold text-base`
      return `text-base`
    })
    return () =>
      h(
        headlineLevel.value,
        {
          class: ['headline ', sizes.value],
        },
        slots.default && slots.default(),
      )
  },
})
</script>
